import { useEffect, useState } from "react";
import { Chip } from "@mui/material";
import { listCategories, getUnits, getStates } from "../../utils/salatMahsoolApi";

const productStatusColors = {
  Active: "success",
  Inactive: "default",
};

const orderStatusColors = {
  Pending: "warning",
  Confirmed: "info",
  Processing: "info",
  Ready: "primary",
  Delivered: "success",
  Cancelled: "error",
};

export const ProductStatusChip = ({ status }) => (
  <Chip
    label={status}
    color={productStatusColors[status] || "default"}
    size="small"
    variant="outlined"
  />
);

export const OrderStatusChip = ({ status }) => (
  <Chip
    label={status}
    color={orderStatusColors[status] || "default"}
    size="small"
    variant="outlined"
  />
);

export const useSalatCategories = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const refetch = () => {
    setLoading(true);
    listCategories()
      .then(setData)
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { categories: data, loading, refetch };
};

export const useUnits = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUnits()
      .then(setData)
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  return { units: data, loading };
};

export const useStates = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getStates()
      .then(setData)
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  }, []);

  return { states: data, loading };
};

export const canWrite = (permissions) => permissions === "admin" || permissions === "operater";
export const canDelete = (permissions) => permissions === "admin";
